import { NativeDateAdapter } from '@angular/material/core';
import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable()
export class VNDateAdapter extends NativeDateAdapter {
    parse(value: any): Date | null {
        if ((typeof value === 'string') && (value.indexOf('/') > -1)) {
            const str = value.split('/');
            if (str.length < 2 || isNaN(+str[0]) || isNaN(+str[1]) || isNaN(+str[2])) {
                return null;
            }
            return new Date(Number(str[2]), Number(str[1]) - 1, Number(str[0]), 12);
        }
        const timestamp = typeof value === 'number' ? value : Date.parse(value);
        return isNaN(timestamp) ? null : new Date(timestamp);
    }
}

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
    parse(value: any): Date | null {

        if (value != null && value != '') {
            if (typeof value === 'string') {
                if (value.indexOf('/') > -1) {
                    const str = value.split('/');

                    const year = Number(str[2]);
                    const month = Number(str[1]) - 1;
                    const date = Number(str[0]);

                    return new Date(year, month, date);
                } else {
                    return new Date(value);
                }
            }
        }
        const timestamp = typeof value === 'number' ? value : Date.parse(value);
        return isNaN(timestamp) ? null : new Date(timestamp);
    }

    format(date: Date, displayFormat: Object): string {
        date = new Date(Date.UTC(
            date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(),
            date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
        displayFormat = Object.assign({}, displayFormat, { timeZone: 'utc' });


        const dtf = new Intl.DateTimeFormat(this.locale, displayFormat);
        return dtf.format(date).replace(/[\u200e\u200f]/g, '');
    }

}

@Injectable()
export class CustomDateAdapterZero extends NativeDateAdapter {
    parse(value: any): Date | null {

        if (value != null && value != '') {
            if (typeof value === 'string') {
                if (value.indexOf('/') > -1) {
                    const str = value.split('/');

                    const year = Number(str[2]);
                    const month = Number(str[1]) - 1;
                    const date = Number(str[0]);

                    return new Date(year, month, date);
                } else {
                    return new Date(value);
                }
            }
        }
        const timestamp = typeof value === 'number' ? value : Date.parse(value);
        return isNaN(timestamp) ? null : new Date(timestamp);
    }

    format(date: Date, displayFormat: Object): string {
        date = new Date(Date.UTC(
          date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(),
          date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
      
        // Sử ddụng toLocaleString() để định dạng ngày tháng
        return date.toLocaleString('vi-VN', { day: '2-digit', month: '2-digit', year: 'numeric' });
      }

}

@Pipe({ name: 'numberFormat' })
export class NumberFormat implements PipeTransform {
    transform(value: any): number {
        return this.localeString(value);
    }

    missingOneDecimalCheck(nStr) {
        nStr += '';
        const x = nStr.split(',')[1];
        if (x && x.length === 1) return true;
        return false;
    }

    missingAllDecimalsCheck(nStr) {
        nStr += '';
        const x = nStr.split(',')[1];
        if (!x) return true;
        return false;
    }

    localeString(nStr) {
        if (nStr === '') return '';
        let x, x1, x2, rgx, y1, y2;
        nStr += '';
        x = nStr.split('.');
        x1 = x[0];
        x2 = x.length > 1 ? ',' + x[1] : '';
        rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + '.' + '$2');
        }

        if (x1.indexOf(',') !== -1) {
            y1 = x1.slice(x1.lastIndexOf(',')).replace(/\./g, '');

            y2 = x1.split(',');
            x = y2[0] +  y1;
        } else {
            x = x1 + x2;
            if (this.missingOneDecimalCheck(x)) return x += '0';
            // if (this.missingAllDecimalsCheck(x)) return x += ',00';
        }

        return x;
    }
}

@Pipe({
    name: 'numberFormatDots'
  })
  export class numberFormatDots implements PipeTransform {
    transform(value: number | string | null, fractionDigits: number = 0): string {
      if (value === null) {
        return '';
      }
  
      let numericValue: number;
      if (typeof value === 'string') {
        numericValue = parseFloat(value);
        if (isNaN(numericValue)) {
          return value;
        }
      } else {
        numericValue = value;
      }  
      return numericValue?.toFixed(fractionDigits).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
  }

@Pipe({ name: 'numberFloatFormat' })
export class numberFloatFormat implements PipeTransform {
    transform(value: any): number {
        return this.localeString(value);
    }

    missingOneDecimalCheck(nStr) {
        nStr += '';
        const x = nStr.split(',')[1];
        if (x && x.length === 1) return true;
        return false;
    }

    missingAllDecimalsCheck(nStr) {
        nStr += '';
        const x = nStr.split(',')[1];
        if (!x) return true;
        return false;
    }

    localeString(nStr) {
        if (nStr === '') return '';
        let x, x1, x2, rgx, y1, y2;
        nStr += '';
        x = nStr.split('.');
        x1 = x[0];
        x2 = x.length > 1 ? ',' + x[1] : '';
        rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + '.' + '$2');
        }

        if (x1.indexOf(',') !== -1) {
            y1 = x1.slice(x1.lastIndexOf(',')).replace(/\./g, '');

            y2 = x1.split(',');
            x = y2[0] +  y1;
        } else {
            x = x1 + x2;
            if (this.missingOneDecimalCheck(x)) return x += '0';
            if (this.missingAllDecimalsCheck(x)) return x += ',000';
        }

        return x;
    }
}
